'use client'
import { motion } from 'framer-motion'

interface BenefitsBarItem {
  title: string
  desc: string
}

interface BenefitsBarProps {
  items: BenefitsBarItem[]
  animated?: boolean
  gridClass?: string
  padding?: string
}

export default function BenefitsBar({
  items,
  animated = true,
  gridClass = 'sm:grid-cols-2 lg:grid-cols-4 gap-6',
  padding = 'py-12',
}: BenefitsBarProps) {
  return (
    <section className="relative border-y border-white/[0.04]">
      <div className={`max-w-7xl mx-auto px-8 sm:px-8 lg:px-8 ${padding}`}>
        <div className={`grid ${gridClass}`}>
          {items.map((item, i) =>
            animated ? (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-50px' }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className="text-center"
              >
                <div className="text-lg font-semibold text-white mb-1">{item.title}</div>
                <div className="text-sm text-[#64748b] leading-relaxed">{item.desc}</div>
              </motion.div>
            ) : (
              <div key={item.title} className="text-center">
                <div className="text-lg font-semibold text-white mb-1">{item.title}</div>
                <div className="text-sm text-[#64748b] leading-relaxed">{item.desc}</div>
              </div>
            )
          )}
        </div>
      </div>
    </section>
  )
}
